/*
 * Mobile/tablet header "dynamic selection bar" toggle.
 * Row 2 shows the vehicle-selection module OR the search module expanded.
 * Tapping the collapsed search icon expands search (vehicle collapses to its
 * icon); tapping the collapsed vehicle icon switches back. The width animation
 * lives in component-header-redesign.css (.list-menu--inline.search-open).
 */
(function () {
  function getBar() {
    return document.querySelector('.header--home-hero .header__inline-menu .list-menu--inline');
  }

  function onClick(e) {
    // Only active where the collapsible layout applies (below the desktop breakpoint).
    if (window.matchMedia('(min-width: 1025px)').matches) return;

    var bar = getBar();
    if (!bar) return;

    var inSearch = e.target.closest('.header__scrolled-search');
    var inVehicle = e.target.closest('.header__vehicle-select');
    var isOpen = bar.classList.contains('search-open');

    if (inSearch && !isOpen) {
      // Expand the search bar; stop the form from submitting on this tap.
      e.preventDefault();
      e.stopPropagation();
      bar.classList.add('search-open');
      var input = bar.querySelector('.header__scrolled-search input[type="search"]');
      if (input) {
        window.setTimeout(function () { input.focus(); }, 420);
      }
    } else if (inVehicle && isOpen) {
      // Collapse search, re-expand the vehicle module; stop the drawer opening.
      e.preventDefault();
      e.stopPropagation();
      bar.classList.remove('search-open');
    }
  }

  /* ---- Desktop "Shop" dropdown: hover intent ----
     Open on pointer enter; close on leave after a short delay so the pointer
     can cross the gap from the "Shop" trigger down into the panel without the
     menu snapping shut (the panel is a descendant of .shop-dropdown, so
     re-entering it cancels the pending close). Keyboard focus also opens it. */
  function initShopDropdown() {
    var CLOSE_DELAY = 220;
    document.querySelectorAll('[data-shop-dropdown]').forEach(function (dd) {
      var timer = null;
      var trigger = dd.querySelector('[data-shop-dropdown-trigger]');

      function open() {
        if (timer) { window.clearTimeout(timer); timer = null; }
        dd.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function scheduleClose() {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          dd.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }

      dd.addEventListener('mouseenter', open);
      dd.addEventListener('mouseleave', scheduleClose);
      dd.addEventListener('focusin', open);
      dd.addEventListener('focusout', function (e) {
        if (!dd.contains(e.relatedTarget)) scheduleClose();
      });
      // Tapping the trigger on touch/narrow screens shouldn't hard-navigate to
      // "#"; let hover/focus drive it (drawer handles Shop below the breakpoint).
      if (trigger && trigger.getAttribute('href') === '#') {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          open();
        });
      }
    });
  }

  /* ---- Slide-in drawer: dedicated close (X) button ----
     The X is its own element attached to the overlay (not a hamburger swap).
     Clicking the drawer's own summary while open runs the theme's full close
     (removes the body scroll-lock too), so we just forward the click. */
  function onDrawerClose(e) {
    var btn = e.target.closest('[data-drawer-close]');
    if (!btn) return;
    e.preventDefault();
    var drawer = btn.closest('header-drawer');
    if (!drawer) return;
    var openDetails = drawer.querySelector('details[open]');
    var summary = drawer.querySelector('summary');
    if (openDetails && summary) summary.click();
  }

  function onSearchReset(e) {
    var form = e.target.closest('.hero-search-bar');
    if (!form) return;
    var input = form.querySelector('.hero-search-bar__input');
    if (!input) return;
    window.setTimeout(function () {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
    }, 0);
  }

  function init() {
    // Capture phase so we intercept before <summary>/<form> default behavior.
    document.addEventListener('click', onClick, true);
    document.addEventListener('click', onDrawerClose);
    document.addEventListener('reset', onSearchReset);
    initShopDropdown();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
